import { HOLIDAYS } from "@/constants/holiday";
import dayjs from "dayjs";

/**
 * dayjs.js のフォーマット失敗時の値
 */
export const INVALID_DATE = "Invalid date";

export function getEndOfMonth(year: number, month: number) {
  return dayjs(`${year}-${("0" + month).slice(-2)}`, "YYYY-MM")
    .endOf("month")
    .date();
}

export function fillZero(num: number, digits: number) {
  const zeroText = [...Array(digits).keys()].map(() => "0").join("");
  return `${zeroText}${num}`.slice(-digits);
}

export function validateDateFormat(date: string, formats: string[]) {
  return formats.some(format => {
    const parsedDate = dayjs(date, format);
    return parsedDate.isValid() && parsedDate.format(format) === date;
  });
}

export const DATE_FORMATS = [
  "YYYY/MM/DD",
  "YYYY/M/D",
  "YYYY年MM月DD日",
  "YYYY年M月D日"
];

export const DATE_WITH_TIME_FORMATS = [
  "YYYY/MM/DD HH:mm",
  "YYYY/M/D H:m",
  "YYYY年MM月DD日 HH時mm分",
  "YYYY年M月D日 H時m分"
];

export function formatDate(date: string, withTime = false) {
  if (!date) return "";
  // NOTE IE11でのdateのフォーマットエラー回避のため一度replaceしている
  return dayjs(new Date(date.replace(/-/g, "/"))).format(
    withTime ? "YYYY/MM/DD HH:mm" : "YYYY/MM/DD"
  );
}

/**
 * Date型ではない YYYY年MM月DD日 を
 * YYYY/MM/DD HH:mm へ変換する
 */
export const formatDisplayDate = (date: string) => {
  let nextDate = date;
  nextDate = nextDate.replace(/年|月/g, "/");
  nextDate = nextDate.replace(/時/g, ":");
  nextDate = nextDate.replace(/日|分/g, "");

  return nextDate;
};

export function formatDateForYearMonthDay(date: string) {
  if (!date) return "";
  return dayjs(date.replace(/-/g, "/")).format("YYYY年MM月DD日");
}

export function thisYear(short: boolean = false) {
  const now = new Date();
  const currentYear = now.getFullYear();
  const thisYear = now.getMonth() > 2 ? currentYear + 2 : currentYear + 1;
  return short ? Number(String(thisYear).slice(-2)) : thisYear;
}

export function isThisYear(graduateYear: number) {
  return graduateYear === thisYear();
}

export function getInitialSelectedChartYears(
  latestYear: number
): [number, number] {
  const now = new Date();
  const month = now.getMonth() + 1;
  const n = latestYear - 1;

  if (4 <= month && month <= 9) {
    return [n - 1, n];
  }
  return [n, n + 1];
}

/** n営業日後の日付を取得 */
export const getBusinessDate = (durationDay: number): dayjs.Dayjs => {
  let businessDate = dayjs();
  let count = 1;

  while (count <= durationDay) {
    businessDate = businessDate.add(1, "day");

    // 土日は営業日とカウントしない
    const day = businessDate.day();
    if ([0, 6].includes(day)) {
      continue;
    }

    // 祝日は営業日とカウントしない
    if (
      HOLIDAYS.some(
        holiday =>
          dayjs(new Date(holiday)).format("YYYY-MM-DD") ===
          businessDate.format("YYYY-MM-DD")
      )
    ) {
      continue;
    }

    count++;
  }

  return businessDate;
};

/**
 * 今日までの日数を取得
 */
export const getDaysToToday = (date: string) => {
  const from = dayjs(date);
  const today = dayjs(Date.now());

  const diffDays = today.diff(from, "days");

  return diffDays;
};

export const unixTimeMSToDateStr = (unixTimeMS: number) => {
  return dayjs(unixTimeMS).format("YYYY/MM/DD");
};

export const unixTimeMsToDateStrJPFormat = (unixTimeMS: number) => {
  return dayjs(unixTimeMS).format("YYYY年MM月DD日");
};

export const unixTimeMSToDateOrTimeStr = (unixTimeMS: number) => {
  const currentDate = dayjs();
  const inputDate = dayjs(unixTimeMS);

  if (currentDate.isSame(inputDate, "day")) {
    return inputDate.format("HH:mm");
  } else {
    return inputDate.format("MM/DD");
  }
};

export const unixTimeMSToTimeStr = (unixTimeMS: number) => {
  const inputDate = dayjs(unixTimeMS);

  return inputDate.format("HH:mm");
};
